"use strict";

module.exports = {
  'shadow-default': '0px 4px 24px rgba(0, 0, 0, .12)',
  'shadow-default-hover': '0px 12px 36px rgba(0, 0, 0, .2)',
  'shadow-sidebar': '4px 0px 24px rgba(0, 0, 0, .12)',
  'shadow-modal': '0px 18px 30px rgba(51, 51, 51, .52)',
  'shadow-modal-mobile': '0px -16px 28px rgba(51, 51, 51, .24)',
  /*
   * @deprecated: instead of this use shadow-dropdown
   */
  'shadow-popover': '0px 25px 15px rgba(0, 0, 0, 0.03), 0px 11px 11px rgba(0, 0, 0, 0.04), 0px 3px 6px rgba(0, 0, 0, 0.05)',
  'shadow-dropdown': '0px 25px 15px rgba(0, 0, 0, 0.03), 0px 11px 11px rgba(0, 0, 0, 0.04), 0px 3px 6px rgba(0, 0, 0, 0.05)',
  'shadow-tooltip': '0px 6px 15px rgba(0,0,0,.2)'
};